import { usePermission } from '@/hooks/usePermission';

/**
 * The VPN's permissions (docs/VpnAccess.md, "Permissions"), asked the way each
 * endpoint authorizes:
 * - `vpn:read`, `vpn:update`: a gateway's VPN and a division's DNS domains,
 *   in the active context;
 * - organization-wide `vpn:update`: the organization's settings and DNS
 *   domains;
 * - `vpn_session:read`: everyone's sessions, the lookup and flow records.
 *
 * Everyone sees their own sessions and devices without any of them.
 */
export function useVpnPermissions() {
  return {
    canReadVpn: usePermission('vpn:read'),
    canUpdateVpn: usePermission('vpn:update'),
    canUpdateOrgVpn: usePermission('vpn:update', 'organization'),
    canReadSessions: usePermission('vpn_session:read'),
  };
}
